import React, { useState } from "react";

import { Icon } from "../../../assets/icons/Icon";
import styles from "./Collapsible.module.scss";
import { CollapsibleProps } from "./types";

export const Collapsible: React.FC<CollapsibleProps> = ({
  title = "Compare all features",
  onToggle,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    onToggle?.(newState);
  };

  return (
    <div
      className={`${styles.collapsible} ${className}`}
      onClick={handleToggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleToggle();
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={isOpen}
      aria-label={`${title}, ${isOpen ? "click to collapse" : "click to expand"}`}
    >
      <span className={styles.collapsibleText}>{title}</span>
      <div
        // @ts-expect-error TS2551 non-existing className
        className={`${styles.collapsible__arrow} ${
          // @ts-expect-error TS2551 non-existing className
          isOpen ? styles["collapsible__arrow--open"] : ""
        }`}
      >
        <span className={styles.collapsibleIcon}>
          <Icon
            iconName="IconDown"
            color="var(--text-black)"
            width="1rem"
            height="1rem"
          />
        </span>
      </div>
    </div>
  );
};
